/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import Account from '../model/Account';
import AqaCanUseResponse from '../model/AqaCanUseResponse';
import AqaPersonResponse from '../model/AqaPersonResponse';
import AqaResponse from '../model/AqaResponse';
import Currency from '../model/Currency';
import Invoice from '../model/Invoice';

/**
* AQAAccountController service.
* @module api/AQAAccountControllerApi
* @version v0
*/
export default class AQAAccountControllerApi {

    /**
    * Constructs a new AQAAccountControllerApi. 
    * @alias module:api/AQAAccountControllerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the delete2FAProfileForUser operation.
     * @callback moduleapi/AQAAccountControllerApi~delete2FAProfileForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes the specified user&#x27;s 2FA data, in effect disabling their 2FA set up
     * @param {String} personId 
     * @param {module:api/AQAAccountControllerApi~delete2FAProfileForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    delete2FAProfileForUser(personId, callback) {
      
      let postBody = null;
      // verify the required parameter 'personId' is set
      if (personId === undefined || personId === null) {
        throw new Error("Missing the required parameter 'personId' when calling delete2FAProfileForUser");
      }

      let pathParams = {
        'personId': personId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/otp/delete/{personId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the deleteAccount operation.
     * @callback moduleapi/AQAAccountControllerApi~deleteAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Deletes an account
     * @param {module:api/AQAAccountControllerApi~deleteAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    deleteAccount(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the doesUserHave2FA operation.
     * @callback moduleapi/AQAAccountControllerApi~doesUserHave2FACallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Check success field, if true: 2FA is set
     * @param {String} personId 
     * @param {module:api/AQAAccountControllerApi~doesUserHave2FACallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    doesUserHave2FA(personId, callback) {
      
      let postBody = null;
      // verify the required parameter 'personId' is set
      if (personId === undefined || personId === null) {
        throw new Error("Missing the required parameter 'personId' when calling doesUserHave2FA");
      }

      let pathParams = {
        'personId': personId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/otp/profile/{personId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAllCurrencies operation.
     * @callback moduleapi/AQAAccountControllerApi~getAllCurrenciesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Currency>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all currencies
     * @param {module:api/AQAAccountControllerApi~getAllCurrenciesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllCurrencies(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Currency];

      return this.apiClient.callApi(
        '/api/v1/accounts/currencies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAllInvoicesForAccounts operation.
     * @callback moduleapi/AQAAccountControllerApi~getAllInvoicesForAccountsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Invoice>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all invoices for account
     * @param {String} accountId 
     * @param {module:api/AQAAccountControllerApi~getAllInvoicesForAccountsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllInvoicesForAccounts(accountId, callback) {
      
      let postBody = null;
      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAllInvoicesForAccounts");
      }

      let pathParams = {
        'accountId': accountId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Invoice];

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/invoices', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getAllInvoicesForMyAccount operation.
     * @callback moduleapi/AQAAccountControllerApi~getAllInvoicesForMyAccountCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Invoice>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves all invoices for my account
     * @param {module:api/AQAAccountControllerApi~getAllInvoicesForMyAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllInvoicesForMyAccount(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Invoice];

      return this.apiClient.callApi(
        '/api/v1/accounts/myInvoices', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getCanUse operation.
     * @callback moduleapi/AQAAccountControllerApi~getCanUseCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaCanUseResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Gets an account&#x27;s status regarding free plan and whether the account can be used.
     * @param {module:api/AQAAccountControllerApi~getCanUseCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getCanUse(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AqaCanUseResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/use', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getInvoice operation.
     * @callback moduleapi/AQAAccountControllerApi~getInvoiceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Invoice{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves one invoice from its id
     * @param {String} invoiceId 
     * @param {module:api/AQAAccountControllerApi~getInvoiceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getInvoice(invoiceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'invoiceId' is set
      if (invoiceId === undefined || invoiceId === null) {
        throw new Error("Missing the required parameter 'invoiceId' when calling getInvoice");
      }

      let pathParams = {
        'invoiceId': invoiceId
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Invoice;

      return this.apiClient.callApi(
        '/api/v1/accounts/invoices/{invoiceId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getMyAccount operation.
     * @callback moduleapi/AQAAccountControllerApi~getMyAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Account{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves account of currently logged user
     * @param {module:api/AQAAccountControllerApi~getMyAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getMyAccount(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Account;

      return this.apiClient.callApi(
        '/api/v1/accounts/me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getPerson operation.
     * @callback moduleapi/AQAAccountControllerApi~getPersonCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaPersonResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns a person object from their id
     * @param {String} id 
     * @param {module:api/AQAAccountControllerApi~getPersonCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getPerson(id, callback) {
      
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPerson");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AqaPersonResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/person/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the getZeroDecimalCurrenciesCodeSet operation.
     * @callback moduleapi/AQAAccountControllerApi~getZeroDecimalCurrenciesCodeSetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * gets Zero Decimal Currencies Codes
     * @param {module:api/AQAAccountControllerApi~getZeroDecimalCurrenciesCodeSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getZeroDecimalCurrenciesCodeSet(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = ['String'];

      return this.apiClient.callApi(
        '/api/v1/accounts/currencies/zdcodes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the stopPaying operation.
     * @callback moduleapi/AQAAccountControllerApi~stopPayingCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes subscription attached to account
     * @param {module:api/AQAAccountControllerApi~stopPayingCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    stopPaying(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/subscriptions', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the updateAccount operation.
     * @callback moduleapi/AQAAccountControllerApi~updateAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AqaResponse{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Updates an account
     * @param {module:model/Account} body 
     * @param {module:api/AQAAccountControllerApi~updateAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    updateAccount(body, callback) {
      
      let postBody = body;
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling updateAccount");
      }

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AqaResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}